// extracted by mini-css-extract-plugin
module.exports = {"singleTweet":"_3RNC0wGH"};